export default {
    black: '#1D1D1D',
    white: '#fff',
    sage: {
        sageDark: '#003C3B',
        sageMedium: '#004F52',
        sageLight: '#407C7D',
    },
    plum: {
        plumDark: '#4A293B',
        plumMedium: '#884E6C',
        plumLight: '#DBC0CE',
    },
    marmalade: {
        marmaladeDark: '#C34600',
        marmaladeMedium: '#FF6626',
        marmaladeLight: '#FF8F5D',
    },
    toast: {
        toastBurnt: '#672500',
        toastDark: '#FFA463',
        toastMedium: '#FFC09C',
        toastLight: '#FFE8D8',
    },
    sunshine: {
        sunshineDark: '#FFBF4B',
        sunshineMedium: '#FFCF7B',
        sunshineLight: '#FFEFD3',
    },
    validation: {
        invalid: '#DA291C',
        valid: '#008C15',
    },
    grey: {
        greyBase: '#5f5f5f',
        greyLight: '#f2f1f0',
    },
    // Home stepper color pairings (background, title, copy if different)
    // Sage 1 - sage.sageDark, homeStepper.white, homeStepper.white
    // Sage 3 - sage.sageLight, sage.sageDark
    // Plum 3 - plum.plumLight, plum.plumDark
    // Grey - sage.sageLight, sage.sageDark, homeStepper.black
    // Toast 2: toast.toastMedium, toast.toastBurnt
    homeStepper: {
        black: '#464646',
        white: '#F2F1F0',
    },
};
